export const buildProposalShareUrl = (proposalId: string): string => {
  return `${window.location.origin}/share/proposal/${proposalId}`;
};
